export const dateHR = (value: number) => {
  const TIME_MULTER = 1000;

  return new Date(value * TIME_MULTER).toLocaleDateString(
    "en-US",
    {
      day: "numeric",
      month: "short",
      year: "numeric",
    }
  );
};
